import dayjs from 'dayjs';

/**
 * Autopilot attempt timestamps arrive as the GraphQL DateTime scalar (typed
 * `any`), so narrow to the value shapes dayjs can parse before formatting.
 * Returns `null` for missing/unparseable values so callers can omit the row.
 */
export const formatAttemptTimestamp = (value: unknown): string | null => {
  if (typeof value !== 'string' && !(value instanceof Date)) {
    return null;
  }

  const parsed = dayjs(value);

  return parsed.isValid() ? parsed.format('MMM D, YYYY h:mm A') : null;
};
